(() => {
  if (document.documentElement.dataset.xrootsSlideshowLinkBound === 'true') return;
  document.documentElement.dataset.xrootsSlideshowLinkBound = 'true';

  const interactiveSelector = 'a, button, input, select, textarea, label, summary';
  const getSlide = (target) => target.closest('[data-xroots-slideshow-link]');
  const canNavigate = (event, slide) => slide && !event.target.closest(interactiveSelector);

  document.addEventListener('click', (event) => {
    if (document.documentElement.classList.contains('xroots-license--restricted')) return;

    const slide = getSlide(event.target);
    if (!canNavigate(event, slide)) return;
    window.location.assign(slide.dataset.xrootsSlideshowLink);
  });

  document.addEventListener('keydown', (event) => {
    if (document.documentElement.classList.contains('xroots-license--restricted')) return;

    if (event.key !== 'Enter' && event.key !== ' ') return;

    const slide = getSlide(event.target);
    if (!canNavigate(event, slide)) return;

    event.preventDefault();
    window.location.assign(slide.dataset.xrootsSlideshowLink);
  });
})();
